import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1b2d58fb"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["inert"];
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "brand-symbol"
}, "A", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "brand-copy"
}, [/*#__PURE__*/_createElementVNode("strong", {
  class: "brand-wordmark"
}, [/*#__PURE__*/_createElementVNode("span", null, "Allen"), /*#__PURE__*/_createElementVNode("em", null, "Blog")]), /*#__PURE__*/_createElementVNode("small", null, "Ideas · Code · Life")], -1));
const _hoisted_4 = [_hoisted_2, _hoisted_3];
const _hoisted_5 = {
  class: "desktop-nav",
  "aria-label": "主导航"
};
const _hoisted_6 = {
  class: "nav-actions"
};
const _hoisted_7 = {
  class: "search-area desktop-only"
};
const _hoisted_8 = ["aria-expanded"];
const _hoisted_9 = {
  class: "search-heading"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("strong", null, "搜索文章"), /*#__PURE__*/_createElementVNode("span", null, "输入标题或正文关键词")], -1));
const _hoisted_11 = {
  class: "search-results",
  "aria-live": "polite"
};
const _hoisted_12 = {
  key: 0,
  class: "search-status"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "正在搜索…", -1));
const _hoisted_14 = {
  key: 1,
  class: "search-status search-error",
  role: "status"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "搜索暂时不可用，请重试。", -1));
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  key: 3,
  class: "search-status"
};
const _hoisted_18 = {
  key: 4,
  class: "search-hint"
};
const _hoisted_19 = {
  class: "account-button",
  type: "button",
  "aria-label": "打开账户菜单"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  class: "desktop-only"
};
const _hoisted_22 = ["aria-expanded"];
const _hoisted_23 = {
  class: "mobile-drawer-content"
};
const _hoisted_24 = {
  class: "mobile-drawer-head"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
  class: "drawer-kicker"
}, "ALLEN BLOG"), /*#__PURE__*/_createElementVNode("h2", null, "浏览与创作")], -1));
const _hoisted_26 = {
  key: 0,
  class: "mobile-search-results",
  "aria-live": "polite"
};
const _hoisted_27 = {
  key: 0,
  class: "mobile-result-status"
};
const _hoisted_28 = {
  key: 1,
  class: "mobile-result-status search-error"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "搜索暂时不可用，请重试。", -1));
const _hoisted_30 = ["onClick"];
const _hoisted_31 = {
  key: 3,
  class: "mobile-result-status"
};
const _hoisted_32 = {
  class: "mobile-links",
  "aria-label": "移动端导航"
};
const _hoisted_33 = ["aria-current", "onClick"];
const _hoisted_34 = {
  class: "mobile-drawer-footer"
};
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { ArrowDown, ArrowRight, Close, EditPen, Headset, HomeFilled, Loading, Menu, Picture, Reading, Search, Setting, SwitchButton, Tools, User } from "@element-plus/icons-vue";
import Login from "@/views/AuthAccess.vue";
import EventBus from "@/utils/EventBus";
import { searchByTitleOrContent } from "@/request/api/article";
import { normalizeFileUrl } from "@/utils/fileUrl";
import { defaultUserAvatar as defaultAvatar } from "@/utils/defaultImages";
import feedback from "@/services/feedback";
export default {
  __name: 'TopNavigation',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const navRoot = ref(null);
    const searchInput = ref(null);
    const searchOpen = ref(false);
    const drawerOpen = ref(false);
    const loginOpen = ref(false);
    const keyword = ref("");
    const searchResults = ref([]);
    const searchLoading = ref(false);
    const searchError = ref(false);
    const isScrolled = ref(false);
    const navHideProgress = ref(0);
    const user = ref({
      avtor: "",
      name: ""
    });
    const pendingRedirect = ref("");
    let searchTimer = null;
    let searchSequence = 0;
    let scrollFrame = 0;
    const navigationLockedOpen = computed(() => searchOpen.value || drawerOpen.value || loginOpen.value);
    const effectiveHideProgress = computed(() => navigationLockedOpen.value ? 0 : navHideProgress.value);
    const isNavConcealed = computed(() => effectiveHideProgress.value >= 0.98);
    const navMotionStyle = computed(() => ({
      opacity: String(1 - effectiveHideProgress.value),
      transform: `translate3d(0, -${(effectiveHideProgress.value * 108).toFixed(2)}%, 0)`
    }));
    const primaryNav = [{
      label: "首页",
      path: "/"
    }, {
      label: "文章",
      path: "/articleList"
    }, {
      label: "工具",
      path: "/tools"
    }];
    const mobileNav = [{
      label: "首页",
      path: "/",
      icon: HomeFilled
    }, {
      label: "文章",
      path: "/articleList",
      icon: Reading
    }, {
      label: "工具",
      path: "/tools",
      icon: Tools
    }, {
      label: "音乐",
      path: "/music",
      icon: Headset
    }, {
      label: "照片墙",
      path: "/imgWall",
      icon: Picture
    }];
    const isLoggedIn = computed(() => store.getters.isTokenValid);
    const isAdmin = computed(() => isLoggedIn.value && user.value?.role === "ADMIN");
    const isLifeActive = computed(() => ["/music", "/imgWall"].some(path => route.path.startsWith(path)));
    const loginDialogWidth = computed(() => window.innerWidth < 768 ? "calc(100vw - 20px)" : "850px");
    const activePathGroups = {
      "/articleList": ["/articleList", "/article/", "/writeArticle", "/editArticleById/"]
    };
    const isActive = path => {
      if (path === "/") return route.path === "/";
      const candidates = activePathGroups[path] || [path];
      return candidates.some(candidate => route.path.startsWith(candidate));
    };
    const syncUser = () => {
      try {
        const storedUser = store.getters.isTokenValid ? JSON.parse(localStorage.getItem("user") || "null") : null;
        user.value = storedUser ? {
          ...storedUser,
          avtor: normalizeFileUrl(storedUser.avtor)
        } : {
          avtor: "",
          name: ""
        };
      } catch (error) {
        user.value = {
          avtor: "",
          name: ""
        };
        console.warn("本地登录信息格式异常，已忽略:", error);
      }
    };
    const navigateTo = path => {
      drawerOpen.value = false;
      searchOpen.value = false;
      if (route.path !== path) router.push(path);
    };
    const toggleSearch = async () => {
      searchOpen.value = !searchOpen.value;
      if (searchOpen.value) {
        await nextTick();
        searchInput.value?.focus?.();
      }
    };
    const closeSearch = () => {
      searchOpen.value = false;
    };
    const resetSearch = () => {
      window.clearTimeout(searchTimer);
      searchSequence += 1;
      searchError.value = false;
      searchResults.value = [];
      searchLoading.value = false;
    };
    const runSearch = async () => {
      const query = keyword.value.trim();
      if (!query) {
        resetSearch();
        return;
      }
      const sequence = ++searchSequence;
      searchLoading.value = true;
      searchError.value = false;
      try {
        const response = await searchByTitleOrContent({
          congTent: query
        });
        if (sequence === searchSequence) searchResults.value = (response.data || []).slice(0, 8);
      } catch (error) {
        if (sequence === searchSequence) {
          searchResults.value = [];
          searchError.value = true;
        }
        console.error("文章搜索失败:", error);
      } finally {
        if (sequence === searchSequence) searchLoading.value = false;
      }
    };
    const scheduleSearch = () => {
      window.clearTimeout(searchTimer);
      if (!keyword.value.trim()) {
        resetSearch();
        return;
      }
      searchSequence += 1;
      searchError.value = false;
      searchResults.value = [];
      searchLoading.value = true;
      searchTimer = window.setTimeout(runSearch, 320);
    };
    const openSearchResult = id => {
      keyword.value = "";
      resetSearch();
      searchOpen.value = false;
      drawerOpen.value = false;
      router.push({
        name: "ArticleDetail",
        params: {
          id
        }
      });
    };
    const handleDocumentClick = event => {
      if (searchOpen.value && navRoot.value && !navRoot.value.contains(event.target)) closeSearch();
    };
    const handleDocumentKeydown = event => {
      if (event.key === "Escape" && searchOpen.value) closeSearch();
    };
    const handleScroll = () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = 0;
        const scrollTop = Math.max(0, window.scrollY);
        isScrolled.value = scrollTop > 18;
        navHideProgress.value = Math.min(1, scrollTop / 120);
      });
    };
    const clearLoginRequest = () => {
      if (!route.query.login && !route.query.redirect) return;
      const query = {
        ...route.query
      };
      delete query.login;
      delete query.redirect;
      router.replace({
        path: route.path,
        query
      });
    };
    const openLoginRequest = (payload = {}) => {
      syncUser();
      pendingRedirect.value = payload.redirect || route.query.redirect || "";
      drawerOpen.value = false;
      searchOpen.value = false;
      loginOpen.value = true;
    };
    const closeLogin = () => {
      loginOpen.value = false;
    };
    const handleLoginClosed = () => {
      if (!isLoggedIn.value) {
        pendingRedirect.value = "";
        clearLoginRequest();
      }
    };
    const handleLoginSuccess = async () => {
      store.commit("checkTokenExpiration");
      if (!store.getters.isTokenValid) return;
      const redirect = pendingRedirect.value || route.query.redirect || (route.name === "LoginPage" ? "/personalCenter" : "");
      pendingRedirect.value = "";
      loginOpen.value = false;
      syncUser();
      if (redirect) {
        await router.replace(redirect);
        return;
      }
      clearLoginRequest();
    };
    const openLoginFromDrawer = () => {
      drawerOpen.value = false;
      loginOpen.value = true;
    };
    const logout = async () => {
      const confirmed = await feedback.confirm({
        title: "退出登录",
        message: "确定退出当前账户吗？再次访问个人内容时需要重新登录。",
        confirmText: "退出",
        cancelText: "保留登录",
        tone: "danger"
      });
      if (!confirmed) return;
      store.commit("delToken");
      syncUser();
      feedback.success({
        title: "已退出",
        message: "当前账户已安全退出。"
      });
      if (route.meta?.requiresAuth) router.push("/");
    };
    watch(() => route.query.login, loginState => {
      if (loginState === "required") openLoginRequest({
        redirect: route.query.redirect
      });
    }, {
      immediate: true
    });
    onMounted(() => {
      syncUser();
      handleScroll();
      EventBus.on("message-sent", handleLoginSuccess);
      EventBus.on("auth-required", openLoginRequest);
      EventBus.on("auth-state-changed", syncUser);
      document.addEventListener("click", handleDocumentClick);
      document.addEventListener("keydown", handleDocumentKeydown);
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
    });
    onBeforeUnmount(() => {
      window.clearTimeout(searchTimer);
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
      EventBus.off?.("message-sent", handleLoginSuccess);
      EventBus.off?.("auth-required", openLoginRequest);
      EventBus.off?.("auth-state-changed", syncUser);
      document.removeEventListener("click", handleDocumentClick);
      document.removeEventListener("keydown", handleDocumentKeydown);
      window.removeEventListener("scroll", handleScroll);
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_drawer = _resolveComponent("el-drawer");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("header", {
        class: _normalizeClass(["top-nav", {
          scrolled: isScrolled.value,
          'nav-concealed': isNavConcealed.value,
          'magazine-nav': ['home', 'articleList', 'ArticleDetail', 'writeArticle', 'editArticleById', 'personalCenter', 'LoginPage', 'imgWall', 'music', 'tools', 'systemManage', 'error', 'notFound'].includes(_unref(route).name)
        }]),
        style: _normalizeStyle(navMotionStyle.value),
        inert: isNavConcealed.value
      }, [_createElementVNode("div", {
        ref_key: "navRoot",
        ref: navRoot,
        class: "nav-container"
      }, [_createElementVNode("button", {
        class: "brand",
        type: "button",
        "aria-label": "返回首页",
        onClick: _cache[0] || (_cache[0] = $event => navigateTo('/'))
      }, _hoisted_4), _createElementVNode("nav", _hoisted_5, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(primaryNav, item => {
        return _createVNode(_component_router_link, {
          key: item.path,
          to: item.path,
          class: _normalizeClass({
            active: isActive(item.path)
          })
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
          _: 2
        }, 1032, ["to", "class"]);
      }), 64)), _createVNode(_component_el_dropdown, {
        trigger: "click",
        "popper-class": "nav-dropdown-popper"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            onClick: _cache[1] || (_cache[1] = $event => navigateTo('/music'))
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(Headset))]),
              _: 1
            }), _createTextVNode("音乐 ")]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: _cache[2] || (_cache[2] = $event => navigateTo('/imgWall'))
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(Picture))]),
              _: 1
            }), _createTextVNode("照片墙 ")]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("button", {
          class: _normalizeClass(["nav-dropdown-trigger", {
            active: isLifeActive.value
          }]),
          type: "button"
        }, [_createTextVNode(" 生活 "), _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(ArrowDown))]),
          _: 1
        })], 2)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("button", {
        class: "icon-button",
        type: "button",
        "aria-label": "搜索文章",
        "aria-expanded": searchOpen.value,
        onClick: _withModifiers(toggleSearch, ["stop"])
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Search))]),
        _: 1
      })], 8, _hoisted_8), _createVNode(_Transition, {
        name: "search-pop"
      }, {
        default: _withCtx(() => [searchOpen.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "search-popover",
          onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
        }, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("button", {
          type: "button",
          "aria-label": "关闭搜索",
          onClick: closeSearch
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Close))]),
          _: 1
        })])]), _createVNode(_component_el_input, {
          ref_key: "searchInput",
          ref: searchInput,
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => keyword.value = $event),
          clearable: "",
          size: "large",
          placeholder: "例如：Vue、Java、随笔",
          "prefix-icon": _unref(Search),
          onInput: scheduleSearch
        }, null, 8, ["modelValue", "prefix-icon"]), _createElementVNode("div", _hoisted_11, [searchLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_el_icon, {
          class: "is-loading"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Loading))]),
          _: 1
        }), _hoisted_13])) : searchError.value ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_hoisted_15, _createElementVNode("button", {
          type: "button",
          onClick: runSearch
        }, "重新搜索")])) : searchResults.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 2
        }, _renderList(searchResults.value, article => {
          return _openBlock(), _createElementBlock("button", {
            key: article.id,
            type: "button",
            onClick: $event => openSearchResult(article.id)
          }, [_createElementVNode("span", null, _toDisplayString(article.title), 1), _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(ArrowRight))]),
            _: 1
          })], 8, _hoisted_16);
        }), 128)) : keyword.value.trim() ? (_openBlock(), _createElementBlock("div", _hoisted_17, "没有找到相关文章")) : (_openBlock(), _createElementBlock("div", _hoisted_18, "输入关键词后将显示匹配文章"))])])) : _createCommentVNode("", true)]),
        _: 1
      })]), _createVNode(_component_el_button, {
        class: "write-button desktop-only",
        icon: _unref(EditPen),
        onClick: _cache[5] || (_cache[5] = $event => navigateTo('/writeArticle'))
      }, {
        default: _withCtx(() => [_createTextVNode(" 写文章 ")]),
        _: 1
      }, 8, ["icon"]), !isLoggedIn.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "primary",
        class: "login-button",
        onClick: _cache[6] || (_cache[6] = $event => loginOpen.value = true)
      }, {
        default: _withCtx(() => [_createTextVNode(" 登录 ")]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 1,
        trigger: "click",
        "popper-class": "nav-dropdown-popper"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            onClick: _cache[7] || (_cache[7] = $event => navigateTo('/personalCenter'))
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(User))]),
              _: 1
            }), _createTextVNode("个人中心 ")]),
            _: 1
          }), isAdmin.value ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 0,
            onClick: _cache[8] || (_cache[8] = $event => navigateTo('/systemManage'))
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(Setting))]),
              _: 1
            }), _createTextVNode("后台管理 ")]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_dropdown_item, {
            divided: "",
            onClick: logout
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_unref(SwitchButton))]),
              _: 1
            }), _createTextVNode("退出登录 ")]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("button", _hoisted_19, [_createVNode(_component_el_avatar, {
          size: 34,
          src: user.value.avtor || _unref(defaultAvatar)
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            class: "default-avatar-image",
            src: _unref(defaultAvatar),
            alt: ""
          }, null, 8, _hoisted_20)]),
          _: 1
        }, 8, ["src"]), _createElementVNode("span", _hoisted_21, _toDisplayString(user.value.name || "用户"), 1), _createVNode(_component_el_icon, {
          class: "desktop-only"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowDown))]),
          _: 1
        })])]),
        _: 1
      })), _createElementVNode("button", {
        class: "mobile-menu-button mobile-only",
        type: "button",
        "aria-label": "打开菜单",
        "aria-expanded": drawerOpen.value,
        onClick: _cache[9] || (_cache[9] = $event => drawerOpen.value = true)
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Menu))]),
        _: 1
      })], 8, _hoisted_22)])], 512), _createVNode(_component_el_drawer, {
        modelValue: drawerOpen.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => drawerOpen.value = $event),
        direction: "rtl",
        size: "min(88vw, 380px)",
        "with-header": false,
        "append-to-body": "",
        class: "mobile-nav-drawer"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("button", {
          type: "button",
          "aria-label": "关闭菜单",
          onClick: _cache[10] || (_cache[10] = $event => drawerOpen.value = false)
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Close))]),
          _: 1
        })])]), _createVNode(_component_el_input, {
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => keyword.value = $event),
          clearable: "",
          size: "large",
          placeholder: "搜索文章",
          "prefix-icon": _unref(Search),
          onInput: scheduleSearch
        }, null, 8, ["modelValue", "prefix-icon"]), keyword.value.trim() ? (_openBlock(), _createElementBlock("div", _hoisted_26, [searchLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_27, "正在搜索…")) : searchError.value ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_hoisted_29, _createElementVNode("button", {
          type: "button",
          onClick: runSearch
        }, "重新搜索")])) : searchResults.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 2
        }, _renderList(searchResults.value, article => {
          return _openBlock(), _createElementBlock("button", {
            key: article.id,
            type: "button",
            onClick: $event => openSearchResult(article.id)
          }, _toDisplayString(article.title), 9, _hoisted_30);
        }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_31, "没有找到相关文章，换个关键词试试。"))])) : _createCommentVNode("", true), _createElementVNode("nav", _hoisted_32, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(mobileNav, item => {
          return _createElementVNode("button", {
            key: item.path,
            type: "button",
            class: _normalizeClass({
              active: isActive(item.path)
            }),
            "aria-current": isActive(item.path) ? 'page' : undefined,
            onClick: $event => navigateTo(item.path)
          }, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))]),
            _: 2
          }, 1024), _createElementVNode("span", null, _toDisplayString(item.label), 1), _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(ArrowRight))]),
            _: 1
          })], 10, _hoisted_33);
        }), 64))]), _createElementVNode("div", _hoisted_34, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(EditPen),
          onClick: _cache[12] || (_cache[12] = $event => navigateTo('/writeArticle'))
        }, {
          default: _withCtx(() => [_createTextVNode("开始写作")]),
          _: 1
        }, 8, ["icon"]), !isLoggedIn.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          onClick: openLoginFromDrawer
        }, {
          default: _withCtx(() => [_createTextVNode("登录账户")]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          onClick: _cache[13] || (_cache[13] = $event => navigateTo('/personalCenter'))
        }, {
          default: _withCtx(() => [_createTextVNode("个人中心")]),
          _: 1
        }))])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: loginOpen.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => loginOpen.value = $event),
        onClosed: handleLoginClosed,
        width: loginDialogWidth.value,
        "align-center": "",
        "destroy-on-close": "",
        "append-to-body": "",
        class: "nav-login-dialog",
        "show-close": false
      }, {
        default: _withCtx(() => [_createElementVNode("button", {
          class: "dialog-close",
          type: "button",
          "aria-label": "关闭登录窗口",
          onClick: closeLogin
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Close))]),
          _: 1
        })]), _createVNode(Login)]),
        _: 1
      }, 8, ["modelValue", "width"])], 14, _hoisted_1);
    };
  }
};